import Typography from '@mui/material/Typography';
// import { Typography } from "@material-ui/core";

import { Card, CardContent, createTheme, Grid } from '@mui/material';
import formatPercent, { formatNumber } from '../../utils/formatValues';

interface DashboardCardProps {
    description: string,
    value: string | number | undefined | null, // TODO: undefined or null or any other value?
    metric: string | undefined
}


export default function DashboardCard({ description, value, metric }: DashboardCardProps) {
    const theme = createTheme({
        components: {
            MuiTypography: {
                styleOverrides: {
                    root: {
                        wordWrap: "break-word"
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        width: "auto",
                        margin: 10,
    
                    },
                },
            },
        },
    });

    // use theme to style Typography component
    // const theme = createTheme({
    //     components: {
    //         MuiTypography: {
    //             styleOverrides: {
    //                 root: {
    //                     wordWrap: "break-word"
    //                 },
    //             },
    //         },
    //     },
    // });

    // access theme inside Typography component


    return (<>
        <Card square={true} sx={{
            // ...(description.length <= 23 ? {
            height: "130px"
            // } : {
            //     height: "150px"
            // }),
        }} >
            
            <CardContent>
                <Grid item container direction="column" xs={12}>
                    <Typography variant="body1" color="text.secondary"    sx={{ wordWrap: "break-word" }}

                    //add line break if word is too long 
                    >                        
                        {description}
                    </Typography>
                    <Typography gutterBottom variant="h6" component="div">
                        {
                        // check if value is a number
                        typeof value === "number" ?
                            // if metric "%", multiply by 100
                            (metric === "%" ? formatPercent(value)  : formatNumber(value) )
                            : // if not number -> str or undefined
                            ((value !== undefined && value !== null) ? value : "No Data")
                        }
                        &nbsp;{metric}
                    </Typography>
                </Grid>
            </CardContent>
        </Card >
    </>
    );

}
